/**
 * Boutons d action sur un document CEE :
 *  - Telecharger (toujours dispo si fichier present)
 *  - Previsualiser (PDF inline, toggle)
 *  - Valider / Rejeter (si status='a_valider')
 *  - Remplacer (si status='valide' ou 'rejete', soft-supersede pour upload nouveau)
 *
 * @param {{
 *   doc: object | null,
 *   onValidate: () => void,
 *   onReject: () => void,
 *   onSupersede: () => void,
 *   onPreviewToggle: () => void,
 *   downloadHref: string,
 *   isPreviewing: boolean,
 *   busy?: boolean,
 *   readOnly?: boolean,
 *   canValidateAsPartner?: boolean,
 * }} props
 *
 * canValidateAsPartner : si true, affiche Valider/Rejeter MEME en mode
 * readOnly. Utilise par les partenaires pour valider Devis/Facture/AH
 * (process Jm 06/05/2026 etape 5). Le backend verifie le scope mandataire.
 */
export default function DocActions({
  doc,
  onValidate,
  onReject,
  onSupersede,
  onPreviewToggle,
  downloadHref,
  isPreviewing,
  busy = false,
  readOnly = false,
  canValidateAsPartner = false,
}) {
  if (!doc) return null;

  const canPreview = doc.mimeType === 'application/pdf' || (doc.filename || '').toLowerCase().endsWith('.pdf');

  return (
    <div className="flex flex-wrap gap-2 mt-3">
      <a
        href={downloadHref}
        download
        className="text-xs px-2.5 py-1.5 bg-gray-100 hover:bg-gray-200 text-[#0f172a] rounded-md font-medium transition-colors"
      >
        Telecharger
      </a>
      {canPreview && (
        <button
          type="button"
          onClick={onPreviewToggle}
          className="text-xs px-2.5 py-1.5 bg-gray-100 hover:bg-gray-200 text-[#0f172a] rounded-md font-medium"
        >
          {isPreviewing ? 'Masquer' : 'Previsualiser'}
        </button>
      )}
      {(!readOnly || canValidateAsPartner) && doc.status === 'a_valider' && (
        <>
          <button
            type="button"
            onClick={onValidate}
            disabled={busy}
            className="text-xs px-2.5 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md font-medium disabled:opacity-50"
          >
            Valider
          </button>
          <button
            type="button"
            onClick={onReject}
            disabled={busy}
            className="text-xs px-2.5 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-md font-medium disabled:opacity-50"
          >
            Rejeter
          </button>
        </>
      )}
      {!readOnly && (doc.status === 'valide' || doc.status === 'rejete') && (
        <button
          type="button"
          onClick={onSupersede}
          disabled={busy}
          className="text-xs px-2.5 py-1.5 bg-white hover:bg-gray-50 text-[#475569] border border-gray-200 rounded-md font-medium"
        >
          Remplacer
        </button>
      )}
    </div>
  );
}
